import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Dayjs } from 'dayjs'
import {
  postMedChangeLog,
  patchMedChangeLog,
  deleteMedChangeLog,
} from '../../../../apis/medChangeLog'
import { queryKeys } from '../../../../shared'

type CreateMedChangeLogParams = {
  med_ippan_name: string
  original_med_name: string
  updated_med_name: string
  start_date: Dayjs
  end_date: Dayjs
  is_scheduled: boolean
}

type UpdateMedChangeLogParams = CreateMedChangeLogParams & {
  id: string
}

/**
 * 薬剤変更ログを新規作成する Mutation hook
 */
export const useCreateMedChangeLogMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateMedChangeLogParams) =>
      postMedChangeLog(
        params.med_ippan_name,
        params.original_med_name,
        params.updated_med_name,
        params.start_date,
        params.end_date,
        params.is_scheduled
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.medChangeLogs.all })
    },
  })
}

/**
 * 薬剤変更ログを更新する Mutation hook
 */
export const useUpdateMedChangeLogMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UpdateMedChangeLogParams) =>
      patchMedChangeLog(
        params.id,
        params.med_ippan_name,
        params.original_med_name,
        params.updated_med_name,
        params.start_date,
        params.end_date,
        params.is_scheduled
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.medChangeLogs.all })
    },
  })
}

/**
 * 薬剤変更ログを削除する Mutation hook
 */
export const useDeleteMedChangeLogMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => deleteMedChangeLog(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.medChangeLogs.all })
    },
  })
}
